module.exports = __webpack_public_path__ + "media/about_us/David-22ca2ba5.png";